import script from "./MailConfirmView.vue?vue&type=script&lang=ts&setup=true"
export * from "./MailConfirmView.vue?vue&type=script&lang=ts&setup=true"

import "./MailConfirmView.vue?vue&type=style&index=0&id=7284a3fc&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7284a3fc"]])

export default __exports__